import { call, takeLatest, all, put } from 'redux-saga/effects';
import api from 'services/api';
import { Types, Creators } from 'store/ducks/module/update';
import { callApi } from 'store/sagas/auth';
import Notifications from 'react-notification-system-redux';
import { push } from 'connected-react-router';

const readFile = file =>
  new Promise(resolve => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(file);
  });

function* getModuleImageUpload(payload) {
  try {
    const { id, image_data } = payload;
    const imageBase64 = yield call(readFile, image_data);
    const data = {
      image: imageBase64,
    };
    const response = yield call(
      api.post,
      `/v1/admin/modules/${id}/images`,
      data,
    );
    return true;
  } catch (err) {
    return false;
  }
}

function* getUpdateModule({ payload }) {
  try {
    const {
      id,
      name,
      description,
      child_group,
      exclusive,
      link,
      status,
      order_position,
      image_data,
      categories,
    } = payload;
    const request = call(api.put, `/v1/admin/modules/${id}`, {
      name,
      description,
      exclusive,
      child_group,
      link,
      status,
      order_position,
      categories,
    });

    const response = yield call(callApi, request);

    if (typeof image_data === 'object' && image_data instanceof File) {
      yield getModuleImageUpload({ id, image_data });
    }

    yield put(Creators.getModuleUpdateSuccess(response.data));
    yield put(Notifications.success({ title: 'Edição concluida com sucesso' }));
    yield put(push(`/modulos/${id}/editar`));
  } catch (err) {
    yield put(Creators.getModuleUpdateFailure('Erro ao buscar na API'));
  }
}

export default function* moduleSaga() {
  yield all([takeLatest(Types.GET_UPDATE_REQUEST, getUpdateModule)]);
}
